<template>
	<div class="fc">
		<Modal
			v-model="$store.state.faceSms.show"
			:title="'身份验证'"
			width="330"
			:z-index="1000"
			@on-visible-change="visibleChange"
			:mask-closable="false"
			:footer-hide="true">
			<div class="fc-type">
				<RadioGroup v-model="faceSms.authType" type="button" @on-change="typeChange">
					<Radio :label="1">短信验证码</Radio>
					<Radio :label="2">支付宝刷脸</Radio>
				</RadioGroup>
			</div>
			<!--短信-->
			<template v-if="faceSms.authType === 1">
				<div class="fc-line">
					<div class="fc-line-label">
						<b>手机号码</b>
					</div>
					<div class="fc-line-main">
						{{ faceSms.mobile | filterForm('sjhm') }}
					</div>
				</div>
				<div class="fc-line">
					<div class="fc-line-label">
						<b>验证码</b>
					</div>
					<div class="fc-line-main">
						<Input v-model="faceSms.dx.code" placeholder="短信验证码"></Input>
					</div>
					<div class="fc-line-btn">
						<Button type="primary" :loading="faceSms.dx.loading" :disabled="faceSms.dx.count !== 0" @click="sendCode">
							<span v-if="faceSms.dx.count === 0">发送验证码</span>
							<span v-else>{{ faceSms.dx.count }}秒后重发</span>
						</Button>
					</div>
				</div>
				<!--				<button @click="complete">完成</button>-->
				<div class="fc-line">
					<div class="fc-line-main">
						<Button
							@click="verCode"
							:disabled="!faceSms.dx.code"
							style="width: 100%"
							:loading="faceSms.dx.subLoading">
							提交验证
						</Button>
					</div>
				</div>
			</template>
			<!--刷脸-->
			<template v-else>
				<div class="fc-face">
					<img v-if="!faceSms.face.success" src alt ref="faceimg" style="width:200px;height:200px;">
					<div v-if="this.faceSms.face.time >= 60">二维码已过期，点此<a @click="getFaceImgCode">刷新</a></div>
				</div>
			</template>
			<Spin size="large" fix v-if="faceSms.loading"></Spin>
		</Modal>
	</div>
</template>

<script>
/*刷脸和短信验证*/
import QRCode from 'qrious'
import { mapState,mapMutations } from 'vuex'

export default {
	name: 'faceSms',
	props: {
		// 所属板块类型  per个人  com单位
		moduleType: {
			type: String,
			default: ''
		},
	},
	computed: mapState({
		faceSms: 'faceSms'
	}),
	data () {
		return {
			code: '',
			type: 'code',
		}
	},
	watch: {
		'faceSms.show': function (show) {
			if(show){
				this.rStart()
			}else {
				this.faceSms.closeFun()
			}
		}
	},
	methods: {
		...mapMutations([
			'closeModal',
		]),
		/**
		 * 发送验证码
		 */
		sendCode () {
			this.faceSms.dx.loading = true
			this.$http
				.post('/ej-isp-api/sms/send-code', {
					mobile: this.faceSms.mobile
				})
				.then(res => {
					if (res.data.code === '0000000') {
						this.countDown()
						this.$Message.success({
							content: '短信发送成功',
							duration: 5
						})
						this.faceSms.dx.loading = false
					} else {
						throw res.data
					}
				})
				.catch(({ message = '短信发送失败,请稍后重试！' }) => {
					debugger
					this.faceSms.dx.loading = false
					this.$Message.warning({
						content: message,
						duration: 10
					})
				})
		},
		/**
		 * 开启倒计时
		 */
		countDown () {
			const TIME_COUNT = 60
			if (!this.faceSms.dx.timer) {
				this.faceSms.dx.count = TIME_COUNT
				this.faceSms.dx.timer = setInterval(() => {
					if (this.faceSms.dx.count > 0 && this.faceSms.dx.count <= TIME_COUNT) {
						this.faceSms.dx.count--
					} else {
						clearInterval(this.faceSms.dx.timer)
						this.faceSms.dx.timer = null
					}
				}, 1000)
			}
		},
		/**
		 * 验证短信验证码
		 */
		verCode () {
			this.faceSms.dx.subLoading = true
			this.$http
				.post('/ej-isp-api/sms/auth-code', {
					mobile: this.faceSms.mobile,
					smsCode: this.faceSms.dx.code
				})
				.then(res => {
					if (res.data.code === '0000000') {
						this.faceSms.dx.subLoading = false
						this.complete()
					} else {
						throw res.data
					}
				})
				.catch(({ message = '验证码错误' }) => {
					this.faceSms.dx.subLoading = false
					this.$Message.warning({
						content: message,
						duration: 3
					})
				})
		},
		/**
		 * 获取刷脸二维码
		 * @returns {Promise<void>}
		 */
		getFaceImgCode () {
			this.faceSms.face.success = false
			this.faceSms.face.time = 0
			const { userName, idNum } = this.faceSms
			this.faceSms.loading = true
			this.$http
				.post('/ej-isp-api/alipay/auth-url', {
					userName, idNum,returnPage:'/'
				})
				.then(({ data }) => {
					if ('0000000' === data.code) {
						const {biz_no,url} = data.body
						this.faceSms.face.bizNo = biz_no
						const dm = this.$refs.faceimg
						
						// 生成二维码
						new QRCode({
							value: url,
							element: dm,
							size: 200
						})
						// 通过轮训的方式查询状态
						if (this.faceSms.face.lunxun) {
							clearInterval(this.faceSms.face.lunxun)
						}
						this.faceSms.face.lunxun = setInterval(async () => {
							this.faceSms.face.time += 1
							// 请求扫码时限制3分钟
							
							if (this.faceSms.face.time >= 60) {
								clearInterval(this.faceSms.face.lunxun)
							} else {
								this.getSearchFace()
							}
							// 每三秒请求一次
						}, 3000)
						
						this.faceSms.loading = false
					}else {
						 throw data
					}
				})
				.catch(() => {
					this.faceSms.loading = false
					// todo 刷脸认证失败
				})
		},
		/**
		 * 查询刷脸结果
		 * @returns {Promise<void>}
		 */
		getSearchFace () {
			const { bizNo } = this.faceSms.face
			const { userName, idNum } = this.faceSms
			this.$http
				.post('/ej-isp-api/alipay/auth', {
					bizNo,
					userName,
					idNum,
				})
				.then((res) => {
					// 验证成功
					if ('0000000' === res.data.code) {
						this.clearFaceInt()
						// 提交成功
						this.complete()
					}
				})
				.catch(() => {
				})
		},
		/**
		 * type change
		 * @param type
		 */
		typeChange (type) {
			this.clearFaceInt()
			switch (type) {
				case 1:
					break
				case 2:
					this.getFaceImgCode()
					break
			}
		},
		/**
		 * 展示验证
		 */
		showModal () {
			// this.getFaceImgCode();
			this.type = 'code'
			this.modal = true
		},
		/**
		 * 模态卡打开或关闭
		 * @param show
		 */
		visibleChange (show) {
			if (!show) {
				this.clearFaceInt()
			}
		},
		/**
		 * 清空刷脸
		 */
		clearFaceInt () {
			this.faceSms.face.lunxun ? clearInterval(this.faceSms.face.lunxun) : ''
		},
		/**
		 * 完成刷脸通知
		 */
		complete(){
			this.closeModal()
			this.faceSms.backFun()
		},
		/**
		 * 重置组件
		 */
		rStart(){
			this.faceSms.dx.code = '';
			this.type = 'code';
		}
	}
}
</script>

<style lang="scss">
.fc {
	&-type {
		display: flex;
		justify-content: center;
		padding: 10px 0 20px;
	}
	
	&-line {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 10px 0;
		
		&-label {
			width: 80px;
			flex-shrink: 0;
			flex-grow: 0;
		}
		
		&-main {
			width: 100%;
			flex-shrink: 1;
			flex-grow: 1;
		}
		
		&-btn {
			flex-shrink: 0;
			flex-grow: 0;
			padding-left: 10px;
		}
	}
	
	&-face {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/faceSms/index.vue